import React from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import { useOpts } from '../../context';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectAmountSelection } from '../../state/slices/slice-amount-selection';
import { selectBankInfos } from '../../state/slices/slice-dd-form';
import { EventAction, EventType } from '../../types/events';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { getAmountSelectionElement } from '../AmountSelection';
import { selectLinkParams } from '../../state/slices/slice-link-params';
import { RemainderSwitchConfirmation, SwitchConfirmation as SwitchConfirmationView, } from '../../views/AmountSelection';
var AmountSelection = function () {
    var opts = useOpts();
    var loadedPlatform = opts.loadedPlatform, linkTokenPayload = opts.linkTokenPayload, experiments = opts.experiments;
    var goBack = useDDFormContext().goBack;
    var navigate = useLinkNavigate();
    var amountSelection = useSelector(selectAmountSelection);
    var bankInfos = useSelector(selectBankInfos);
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var linkParams = useSelector(selectLinkParams);
    var handleContinue = function () {
        opts.fireUnifiedEvent(EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT, {
            action: EventAction.CONTINUE,
            allocation: {
                amountSelection: amountSelection,
                targets: bankInfos,
            },
            entry_point: lastSource,
            source: currentSource,
        });
        navigate(bankInfos.length > 1
            ? '/dd-form/multiple-account-selection'
            : (bankInfos === null || bankInfos === void 0 ? void 0 : bankInfos.length) === 0 && (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.enableUserInputBankInfo)
                ? '/dd-form/bank-info-input'
                : '/dd-form/confirmation-screen');
    };
    var NextComponent;
    if (linkTokenPayload.disableDirectDepositSplitting ||
        // If the user hasn't selected a platform, we should use an amount selection screen
        (loadedPlatform && !(loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.amountSupported))) {
        NextComponent =
            !(loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.fullSwitchSupported) &&
                !experiments.confirmationScreenEnabled
                ? RemainderSwitchConfirmation
                : SwitchConfirmationView;
    }
    else {
        NextComponent = getAmountSelectionElement(linkParams, loadedPlatform);
    }
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack, "data-testid": "DDFormAmountSelection" }),
        React.createElement(ContentFrame, null,
            React.createElement(NextComponent, { onContinue: handleContinue }))));
};
export default AmountSelection;
